;(function() {
  'use strict'

  Controller.$inject = ["$filter", "quotaCellStateService", "quotaTextService", "QuotaPlan"];
  angular.module('app.core').component('quotaCellInput', {
    controller: Controller,
    templateUrl: 'quota-cell-input.html',
    bindings: {
      cellKey: '<',
      target: '<',
      achieved: '<',
      isFocused: '<',
      onChange: '&',
      onFocusRequest: '&',
    },
  })

  /* @ngInject */
  function Controller(
    $filter,
    quotaCellStateService,
    quotaTextService,
    QuotaPlan
  ) {
    var ctrl = this

    var MAX_DIGITS = String(QuotaPlan.MAX_TARGET).length

    var numberFilter = $filter('number')

    ctrl.$onChanges = onChanges

    ctrl.onInput = onInput
    ctrl.onFocus = onFocus
    ctrl.getState = getState
    ctrl.hasBar = hasBar
    ctrl.getFillPercent = getFillPercent
    ctrl.getRemaining = getRemaining
    ctrl.getStatParts = getStatParts
    ctrl.getHint = getHint

    function onChanges(changes) {
      if (changes.target) {
        // 0 is a real target and has to render as 0, so this tests for a number rather than for truthiness
        ctrl.text = _.isNumber(ctrl.target) ? String(ctrl.target) : ''
      }
    }

    function onInput() {
      var text = _.isNil(ctrl.text) ? '' : String(ctrl.text)
      var digits = text.replace(/[^0-9]/g, '').slice(0, MAX_DIGITS)

      if (digits !== text) {
        ctrl.text = digits
      }

      ctrl.onChange({
        cellKey: ctrl.cellKey,
        // an empty box means no limit and 0 means closed, so blank becomes null and never 0
        value: digits.length ? parseInt(digits, 10) : null,
      })
    }

    function onFocus() {
      ctrl.onFocusRequest({ cellKey: ctrl.cellKey })
    }

    function getState() {
      return quotaCellStateService.getState(ctrl.target, ctrl.achieved)
    }

    function hasBar() {
      return quotaCellStateService.hasBar(ctrl.target)
    }

    function getFillPercent() {
      return quotaCellStateService.getFillPercent(ctrl.target, ctrl.achieved)
    }

    function getRemaining() {
      return quotaCellStateService.getRemaining(ctrl.target, ctrl.achieved)
    }

    function getStatParts() {
      return quotaTextService.formatProgress(ctrl.achieved, ctrl.target, false)
    }

    function getHint() {
      if (getState() === quotaCellStateService.States.CLOSED) {
        return 'Closed to new responses'
      }

      var remaining = getRemaining()
      if (remaining === null) return 'No limit set'
      return numberFilter(remaining) + ' remaining'
    }
  }
})()
